import React from 'react';
import { PartnerEcosystemSVG } from './SVGs/WhySectionSVGs';

const PartnerSection = () => {
  return (
    <section id="partners" className="partners-section">
      <div className="container">
        <div className="section-header">
          <span className="label">partner ecosystem</span>
          <h2>Partner With ProcureForEU</h2>
          <p>A Long-Term Manufacturing Partnership — Not Just Orders. We are not looking for volume-only suppliers. We are building long-term partners who want to grow, upgrade, and compete globally.</p>
        </div>
        
        {/* Partner SVG at top */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
          <div style={{ width: '150px' }}>
            <PartnerEcosystemSVG />
          </div>
        </div>
        
        <div className="partners-grid">
          <div className="partner-card">
            <h4><i className="fas fa-users"></i> A Limited & Curated Vendor Pool</h4>
            <p>ISO, proven capability, commitment to quality & sustainability. Selective approach ensures higher order stability, deeper collaboration, and mutual growth.</p>
            <div className="tags">
              <span className="pill-tag">ISO</span>
              <span className="pill-tag">quality</span>
              <span className="pill-tag">compliance</span>
              <span className="pill-tag">scalability</span>
            </div>
          </div>
          <div className="partner-card">
            <h4><i className="fas fa-chart-line"></i> Vendor Development Programs</h4>
            <p>DFM workshops, EU standards training, sustainability guidance — we invest in your growth. Help partners move up the value chain, not remain price-driven suppliers.</p>
          </div>
          <div className="partner-card">
            <h4><i className="fas fa-hard-hat"></i> On-Site Support & In-House Quality</h4>
            <p>Manufacturing engineers, design specialists, and quality engineers on the ground for process validation, inspections, and continuous improvement planning.</p>
          </div>
          <div className="partner-card">
            <h4><i className="fas fa-star"></i> Performance-Based Loyalty & Rewards</h4>
            <p>KPI-based rewards: quality, delivery, compliance, sustainability. High-performing partners gain priority projects, long-term volume commitments, and co-development opportunities.</p>
          </div>
        </div>
        <div className="partners-cta">
          <p><i className="fas fa-plane"></i> Select partners get EU exposure — sponsored visits, training sessions, client collaboration, and access to advanced manufacturing technologies.</p>
          <div className="actions" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.75rem', marginTop: '1rem' }}>
            <button className="btn-eu">Apply as Manufacturing Partner</button>
            <button className="btn-outline">Download Vendor Program Overview</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerSection;